export default class Workflow {
    constructor(adapter, ref)
    {
        this.ref = ref
        this.client = adapter.getPlatformClient()
    }

    trigger(event, input) {
        return this.client.post("/v1/system/component/" + this.ref + "/workflow/event", {
            event,
            input
        })
    }
}